import Rest from '../Rest'

export default class SubscriptionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/subscriptions'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  findAllPlans() {
    return this.get('/plans')
  }

  findAllStatuses() {
    return this.get('/statuses')
  }

  cancel(id: number, cancellationReason?: string) {
    return this.post(`/${id}/cancel`, { cancellation_reason: cancellationReason })
  }

  find(id: number) {
    return this.read(id)
  }

  /** Grade de horários fixos do assinante + horários elegíveis para troca. */
  getSlots(id: number | string) {
    return this.get(`/${id}/slots`)
  }

  updateSlots(id: number | string, payload: any) {
    return this.put(`/${id}/slots`, payload)
  }
}
